import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import TimesheetFilters from "../components/Timesheet/TimesheetFilters";
import TimesheetDailyView from "../components/Timesheet/TimesheetDailyView";
import TimesheetWeeklyView from "../components/Timesheet/TimesheetWeeklyView";
import TimesheetMonthlyView from "../components/Timesheet/TimesheetMonthlyView";
import TimesheetCustomRangeView from "../components/Timesheet/TimesheetCustomRangeView"; // 👈 new import

const AdminTimesheetPage = () => {
  const [activeView, setActiveView] = useState("daily");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  // For custom range
  const [rangeStart, setRangeStart] = useState(new Date());
  const [rangeEnd, setRangeEnd] = useState(new Date());

  return (
    <MasterLayout>
      <Breadcrumb title="Timesheet Management" />

      <div className="container-fluid mt-3">
        <TimesheetFilters
          activeView={activeView}
          setActiveView={setActiveView}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          selectedEmployee={selectedEmployee}
          setSelectedEmployee={setSelectedEmployee}
          rangeStart={rangeStart}
          setRangeStart={setRangeStart}
          rangeEnd={rangeEnd}
          setRangeEnd={setRangeEnd}
        />

        <div className="mt-4">
          {activeView === "daily" && (
            <TimesheetDailyView date={selectedDate} employee={selectedEmployee} />
          )}
          {activeView === "weekly" && (
            <TimesheetWeeklyView date={selectedDate} employee={selectedEmployee} />
          )}
          {activeView === "monthly" && (
            <TimesheetMonthlyView date={selectedDate} employee={selectedEmployee} />
          )}
          {activeView === "custom" && (
            <TimesheetCustomRangeView
              startDate={rangeStart}
              endDate={rangeEnd}
              employee={selectedEmployee}
            />
          )}
        </div>
      </div>
    </MasterLayout>
  );
};

export default AdminTimesheetPage;
